import { useState } from 'react';

import ExpandLessIcon from '@mui/icons-material/ExpandLess';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Collapse from '@mui/material/Collapse';
// import IconButton from '@mui/material/IconButton'
import styled from '@mui/material/styles/styled';
import TableCell from '@mui/material/TableCell';
import TableRow from '@mui/material/TableRow';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';

import Text from '../../../elements/text/Text';

const StyledTableRow = styled(TableRow)({
  '& > *': {
    borderBottom: 'unset',
  },
});

const CollapsibleRow = ({ rowHeader, colSpan, children }) => {
  const { t } = useTranslation();
  const [open, setOpen] = useState(false);

  return (
    <>
      <StyledTableRow>
        <TableCell>
          <Box sx={{ display: 'flex', justifyContent: 'space-between' }}>
            <Text bodyBold>{rowHeader}</Text>
          </Box>
        </TableCell>
        <TableCell>
          <Box sx={{ display: 'flex' }}>
            <Button
              color="inherit"
              sx={{ marginLeft: '-0.5em' }}
              variant="text"
              size="small"
              onClick={() => setOpen(!open)}
              endIcon={open ? <ExpandLessIcon /> : <ExpandMoreIcon />}
            >
              {t('clickForDetails', { ns: 'buttons' })}
            </Button>
          </Box>
        </TableCell>
      </StyledTableRow>
      <TableRow>
        <TableCell
          colSpan={colSpan}
          style={{ paddingBottom: 0, paddingTop: 0 }}
        >
          <Collapse in={open} timeout="auto" unmountOnExit>
            {children}
          </Collapse>
        </TableCell>
      </TableRow>
    </>
  );
};

CollapsibleRow.propTypes = {
  rowHeader: PropTypes.string.isRequired,
  colSpan: PropTypes.number.isRequired,
  children: PropTypes.node.isRequired,
};

export default CollapsibleRow;
